import React from 'react';
import { JdsTag } from '../../../../components/jds/JdsTag';

const COUPON_STATUS_BADGES = {
  active: { label: 'Ativo', color: 'success' },
  scheduled: { label: 'Agendado', color: 'info' },
  paused: { label: 'Pausado', color: 'warning' },
  expired: { label: 'Expirado', color: 'error' },
};

export function getCouponStatus(coupon) {
  if (!coupon?.active) return 'paused';
  if (coupon?.expiresAt && new Date(coupon.expiresAt) < new Date())
    return 'expired';
  if (coupon?.startsAt && new Date(coupon.startsAt) > new Date())
    return 'scheduled';
  return 'active';
}

export function CouponStatusBadge({ coupon }) {
  const badge = COUPON_STATUS_BADGES[getCouponStatus(coupon)];

  return <JdsTag label={badge.label} color={badge.color} dot />;
}
